// extracted by mini-css-extract-plugin
export default {"container":"styles_container__N5Bu6","parent":"styles_parent__9HkdO"};